import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDollarImac = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a,.b{fill:none;}.a{stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M18.429,17H5.571A2.571,2.571,0,0,1,3,14.429V5.571A2.571,2.571,0,0,1,5.571,3H18.428A2.571,2.571,0,0,1,21,5.571v8.857A2.571,2.571,0,0,1,18.429,17Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M14,17l.5,4"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M10,17l-.5,4"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M8.14,21h7.72"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M12,7V6"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M12,13v1"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M10.264,12.286A1.442,1.442,0,0,0,11.5,13h1.1a1.4,1.4,0,0,0,.341-2.766l-1.875-.47A1.405,1.405,0,0,1,11.4,7h1.1a1.444,1.444,0,0,1,1.234.714"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M0,0H24V24H0Z"
		})
	]
});
export default SvgDollarImac;
